export const SCORE_CELEBRATION_DURATION_MS = 2200;

export const getScoreCelebrationType = (points, isWinningThrow) => {
  if (isWinningThrow && points === 170) {
    return 'checkout170';
  }

  if (points === 180) {
    return 'score180';
  }

  return null;
};

export const shouldDelayResultModalForCelebration = (points) => points === 170;